import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCardActivateFiltering } from './Pages';

export const EmployeeCardActivateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeCardActivateFiltering} />
    </Fragment>
)